"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureText = void 0;
exports.measureText = function (text, canvas) {
    var ctx = canvas.getContext("2d");
    ctx.save();
    ctx.font = text.fontStyle + " " + text.fontWeight + " " + text.fontSize + "px " + text.fontFamily;
    var metrics = ctx.measureText(text.content);
    ctx.restore();
    var computedHeight = metrics.fontBoundingBoxAscent && metrics.fontBoundingBoxDescent
        ? metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent
        : text.fontSize * 1.2;
    return {
        width: metrics.width * 1.1,
        height: computedHeight
    };
};
//# sourceMappingURL=measureText.js.map